import React from "react";

let AdminFooter = () => {
  return (
    <div>
      <footer className="main-footer">
        Copyright © 2021-2022 <b>Saraca Solutions. </b>
        All rights reserved.
        <div className="float-right d-none d-sm-inline-block">
          <b>Version</b> 2.0
        </div>
      </footer>
    </div>
  );
};

export default AdminFooter;
